// "flory.sh" mark: two chain-link ovals whose gap is an open door — linked, but out in the open.
export function LinkMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <rect
        x="2.5"
        y="9"
        width="15"
        height="14"
        rx="7"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      />
      {/* right link, opened: a door-shaped gap on its left edge */}
      <path d="M21 9h1.5a7 7 0 0 1 0 14H21" fill="none" stroke="currentColor" strokeWidth="3" />
      <path d="M17.5 12.5 21 9v14l-3.5-3.5z" fill="var(--signal)" />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-2 font-display text-xl font-bold tracking-tight ${className ?? ''}`}
    >
      <LinkMark />
      <span>flory.sh</span>
    </span>
  );
}
